// extracted by mini-css-extract-plugin
export default {"overdue":"MaintenanceStatus_overdue__iXwu9"};